<div class="container" style="height: 80vh; overflow-y: auto">
  <div style="display: flex; align-items: center; justify-content: center; margin: 12px 0 12px 0">
    <mat-form-field style="width: 95%" class="mat-form-field-no-padding-margin">
      <mat-label>Suche</mat-label>
      <input matInput [formControl]="searchCtrl" placeholder="Suche" />
      <button
        mat-icon-button
        matSuffix
        [disabled]="searchCtrl?.value?.length <= 0"
        (click)="searchCtrl.setValue('')"
        >
        <mat-icon>clear</mat-icon>
      </button>
    </mat-form-field>
  </div>

  @if (settings.length > 0) {
    <div>
      <mat-list>
        @for (setting of settings; track setting) {
          <div>
            <div style="width: 100%; margin-bottom: 24px" class="setting-item">
              <div class="one-row">
                <div style="margin-right: 12px">
                  @if (anyChecked(setting)) {
                    <mat-icon color="accent">notifications_active</mat-icon>
                  }
                  @if (!anyChecked(setting)) {
                    <mat-icon>notifications</mat-icon>
                  }
                </div>
                <strong>{{ setting.notificationAction }}</strong>
              </div>
              <mat-list>
                <div style="display: flex; align-items: center; justify-content: space-around" matLine>
                  <mat-slide-toggle
                    (change)="addSubscription($event, subscriptionType.UI, setting)"
                    [checked]="isChecked(subscriptionType.UI, setting)"
                    >
                    Banner
                  </mat-slide-toggle>
                  <mat-slide-toggle
                    (change)="addSubscription($event, subscriptionType.EMAIL, setting)"
                    [checked]="isChecked(subscriptionType.EMAIL, setting)"
                    >
                    E-Mail
                  </mat-slide-toggle>
                </div>
              </mat-list>
            </div>
          </div>
        }
      </mat-list>
    </div>
  }
</div>
